import * as Actions from './actions';

export function tillerBackReducer(state = null, action) {
  switch (action.type) {
    case Actions.CREATE_TILLER_BACK_OFFICE:
      return null;
    case Actions.BACK_OFFICE_CREATED:
      return action.tillerBack;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/TillerBackService/reducers.js